import dayjs from 'dayjs';
import { i18n } from '@/app/lang/i18n.js';
import availableLanguages from '@/app/lang/available-languages.js';
import { useAuthStore } from '#modules/auth/stores/auth.store.js';

export function setLanguage(lang = null) {
    const authStore = useAuthStore();

    if (!lang) {
        lang = navigator.language.split('-')[0]; // fallback
    }

    if (authStore.user && authStore.language) {
        lang = authStore.language;
    }

    if (!availableLanguages.find((l) => l.locale === lang)) {
        console.warn(`"${lang}" is not an available language.`);
    } else {
        i18n.global.locale.value = lang;
        dayjs.locale(lang);

        document.querySelector('html').setAttribute('lang', lang);
    }
}
